export default __webpack_public_path__ + "static/media/skippedmeal@3x.3baf7332.jpg";